export default {
    entityKey: 'accountApplications',
    titles: {
        singular: 'Account Application',
        plural: 'Account Applications'
    }
}